/* HS · R'EFECT front-end layer.
   Front-end only: no change to Hyper's product, cart or checkout calls.
   1. Native wishlist (hearts on cards + PDP, wishlist page)
   2. Auto-scrolling brand-logo strip
   3. HS product sliders (arrows for .hs-slider)                                  */
(function () {
  'use strict';

  /* ---------------- 1. Wishlist ---------------- */
  var KEY = 'hs_wishlist_v1';
  var cfg = window.HSWishlistConfig || {};   // { endpoint: '/apps/hs/wishlist', customerId: 123 }

  function read() {
    try { return JSON.parse(localStorage.getItem(KEY) || '[]'); } catch (e) { return []; }
  }
  function write(list) {
    try { localStorage.setItem(KEY, JSON.stringify(list)); } catch (e) {}
    document.dispatchEvent(new CustomEvent('hs:wishlist:change', { detail: { list: list } }));
    syncUp(list);
  }
  // Logged-in customers: the list is saved to their Shopify account through the HS app proxy
  // (customer metafield hs.wishlist). Guests keep it in this browser until they log in.
  function syncUp(list) {
    if (!cfg.endpoint || !cfg.customerId) return;
    try {
      fetch(cfg.endpoint, { method: 'POST', headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ customer_id: cfg.customerId, handles: list }) }).catch(function () {});
    } catch (e) {}
  }
  function mergeFromAccount() {
    if (!cfg.customerId || !Array.isArray(cfg.saved)) return;
    var merged = read();
    cfg.saved.forEach(function (h) { if (merged.indexOf(h) === -1) merged.push(h); });
    try { localStorage.setItem(KEY, JSON.stringify(merged)); } catch (e) {}
    if (merged.length !== cfg.saved.length) syncUp(merged);
  }
  function paint() {
    var list = read();
    document.querySelectorAll('[data-hs-wish]').forEach(function (b) {
      b.setAttribute('aria-pressed', list.indexOf(b.getAttribute('data-hs-wish')) > -1 ? 'true' : 'false');
    });
    document.querySelectorAll('[data-hs-wish-count]').forEach(function (n) {
      n.textContent = list.length; n.hidden = list.length === 0;
    });
  }
  document.addEventListener('click', function (e) {
    var b = e.target.closest && e.target.closest('[data-hs-wish]');
    if (!b) return;
    e.preventDefault(); e.stopPropagation();
    var h = b.getAttribute('data-hs-wish'), list = read(), i = list.indexOf(h);
    if (i > -1) list.splice(i, 1); else list.unshift(h);
    write(list); paint();
  }, true);
  document.addEventListener('hs:wishlist:change', paint);

  // Wishlist page: server-rendered cards via the product "hs-card" view
  function renderWishlistPage() {
    var root = document.querySelector('[data-hs-wishlist-grid]');
    if (!root) return;
    var empty = document.querySelector('[data-hs-wishlist-empty]');
    var list = read();
    if (!list.length) { root.innerHTML = ''; if (empty) empty.hidden = false; return; }
    if (empty) empty.hidden = true;
    Promise.all(list.map(function (h) {
      return fetch('/products/' + encodeURIComponent(h) + '?view=hs-card')
        .then(function (r) { return r.ok ? r.text() : ''; }).catch(function () { return ''; });
    })).then(function (cards) {
      root.innerHTML = cards.filter(Boolean).map(function (c) { return '<div class="hs-wishlist__item">' + c + '</div>'; }).join('');
      paint();
    });
  }
  document.addEventListener('hs:wishlist:change', function () {
    if (document.querySelector('[data-hs-wishlist-grid]')) renderWishlistPage();
  });

  /* ---------------- 2. Brand logos: auto-scroll ---------------- */
  function initMarquee() {
    document.querySelectorAll('[data-hs-marquee]').forEach(function (wrap) {
      if (wrap.dataset.hsReady) return;
      var track = wrap.querySelector('[data-hs-marquee-track]');
      if (!track) return;
      track.innerHTML += track.innerHTML;          // seamless loop
      wrap.dataset.hsReady = '1';
    });
  }

  /* ---------------- 3. HS sliders (arrows) ---------------- */
  function initSliders() {
    document.querySelectorAll('.hs-slider').forEach(function (s) {
      if (s.dataset.hsReady) return;
      var track = s.querySelector('.hs-slider__track');
      var prev = s.querySelector('[data-hs-prev]'), next = s.querySelector('[data-hs-next]');
      if (!track) return;
      function step() { var c = track.querySelector('.hs-slider__item'); return c ? c.getBoundingClientRect().width + 12 : track.clientWidth; }
      function upd() {
        if (prev) prev.disabled = track.scrollLeft <= 2;
        if (next) next.disabled = track.scrollLeft + track.clientWidth >= track.scrollWidth - 2;
      }
      if (prev) prev.addEventListener('click', function () { track.scrollBy({ left: -step() * 2, behavior: 'smooth' }); });
      if (next) next.addEventListener('click', function () { track.scrollBy({ left: step() * 2, behavior: 'smooth' }); });
      track.addEventListener('scroll', upd, { passive: true });
      upd(); s.dataset.hsReady = '1';
    });
  }

  /* ---------------- 4. PDP delivery options (display only) ---------------- */
  document.addEventListener('click', function (e) {
    var b = e.target.closest && e.target.closest('.hs-dopt');
    if (!b) return;
    var wrap = b.closest('[data-hs-delivery]'); if (!wrap) return;
    wrap.querySelectorAll('.hs-dopt').forEach(function (x) { x.setAttribute('aria-pressed', x === b ? 'true' : 'false'); });
    var line = wrap.querySelector('[data-hs-delivery-line]');
    if (line && b.dataset.line) line.innerHTML = b.dataset.line;
  });

  function init() { mergeFromAccount(); paint(); renderWishlistPage(); initMarquee(); initSliders(); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
  // Theme editor + section re-renders (filters, quick view)
  document.addEventListener('shopify:section:load', init);
  var queued = false;
  new MutationObserver(function () {
    if (queued) return; queued = true;
    requestAnimationFrame(function () { queued = false; paint(); initSliders(); initMarquee(); });
  }).observe(document.body || document.documentElement, { childList: true, subtree: true });
})();

/* HS · simple tabs for HS sections (Shop the routines) */
document.addEventListener('click', (e) => {
  const t = e.target.closest('[data-hs-tab]');
  if (!t) return;
  const root = t.closest('[data-hs-tabs]');
  if (!root) return;
  const i = t.getAttribute('data-hs-tab');
  root.querySelectorAll('[data-hs-tab]').forEach((b) => b.setAttribute('aria-selected', String(b === t)));
  root.querySelectorAll('[data-hs-panel]').forEach((p) => { p.hidden = p.getAttribute('data-hs-panel') !== i; });
});

/* HS · "Add to Basket — 5,850 EGP" (prototype): price suffix in its own span (hidden by CSS when the button is narrow) */
(function () {
  const fmt = (s) => s.replace(/\s+/g, ' ').trim().replace(/\.00(?=\s|$)/, '');
  function run() {
    document.querySelectorAll('.section-main-product .product-form .product-form__submit .btn__text').forEach((t) => {
      const btn = t.closest('button');
      const root = t.closest('.product') || document;
      let sp = t.querySelector('.hs-atc-p');
      const base = (sp ? t.textContent.replace(sp.textContent, '') : t.textContent.split(' — ')[0]).trim();
      if (btn.disabled) { if (sp) sp.remove(); return; }
      const pe = root.querySelector('.product__block--price .f-price__sale .f-price-item--sale') || root.querySelector('.product__block--price .f-price-item--regular') || root.querySelector('.product__block--price .f-price-item');
      if (!pe) return;
      const suffix = ' — ' + fmt(pe.textContent);
      if (!sp) { t.textContent = base; sp = document.createElement('span'); sp.className = 'hs-atc-p'; t.appendChild(sp); }
      if (sp.textContent !== suffix) sp.textContent = suffix;
    });
  }
  let raf = 0;
  const schedule = () => { if (!raf) raf = requestAnimationFrame(() => { raf = 0; run(); }); };
  document.addEventListener('DOMContentLoaded', run);
  new MutationObserver(schedule).observe(document.documentElement, { subtree: true, childList: true, characterData: true });
})();

/* HS · Brands A–Z: group the vendor list by letter, letter rail, search and group chips */
(function () {
  function init(root) {
    if (root.dataset.hsReady) return; root.dataset.hsReady = '1';
    const flat = root.querySelector('[data-hs-brands-flat]');
    const list = root.querySelector('[data-hs-brands-list]');
    const empty = root.querySelector('[data-hs-brands-empty]');
    const featured = root.querySelector('[data-hs-brands-featured]');
    const q = root.querySelector('[data-hs-brands-q]');
    if (!flat || !list) return;
    const items = [...flat.children].sort((a, b) => a.dataset.n.localeCompare(b.dataset.n));
    const groups = {};
    items.forEach((li) => { (groups[li.dataset.l] = groups[li.dataset.l] || []).push(li); });
    const order = Object.keys(groups).sort((a, b) => (a === '#' ? -1 : b === '#' ? 1 : a.localeCompare(b)));
    order.forEach((l) => {
      const sec = document.createElement('section'); sec.className = 'hs-brands__grp'; sec.id = 'hs-brands-' + (l === '#' ? 'num' : l); sec.dataset.l = l;
      sec.innerHTML = '<h2 class="hs-brands__L">' + l + '</h2>';
      const ul = document.createElement('ul'); groups[l].forEach((li) => ul.appendChild(li)); sec.appendChild(ul); list.appendChild(sec);
    });
    flat.remove();
    let g = 'all';
    const rail = [...root.querySelectorAll('[data-hs-brands-l]')];
    function apply() {
      const term = (q && q.value || '').trim().toLowerCase();
      let any = 0;
      list.querySelectorAll('.hs-brands__grp').forEach((sec) => {
        let n = 0;
        sec.querySelectorAll('li').forEach((li) => {
          const ok = li.dataset.g.split(' ').includes(g) && (!term || (' ' + li.dataset.n.replace(/[^a-z0-9\u00c0-\u024f]+/g, ' ')).includes(' ' + term) || li.dataset.n.startsWith(term));
          li.hidden = !ok; if (ok) n++;
        });
        sec.hidden = n === 0; any += n;
        const b = rail.find((x) => x.dataset.hsBrandsL === sec.dataset.l); if (b) b.disabled = n === 0;
      });
      rail.forEach((b) => { if (!list.querySelector('.hs-brands__grp[data-l="' + b.dataset.hsBrandsL + '"]')) b.disabled = true; });
      if (empty) empty.hidden = any > 0;
      if (featured) featured.hidden = !!term || g !== 'all';
    }
    if (q) q.addEventListener('input', apply);
    root.querySelectorAll('[data-hs-brands-g]').forEach((b) => b.addEventListener('click', () => {
      g = b.dataset.hsBrandsG;
      root.querySelectorAll('[data-hs-brands-g]').forEach((x) => x.setAttribute('aria-pressed', x === b ? 'true' : 'false'));
      apply();
    }));
    rail.forEach((b) => b.addEventListener('click', () => {
      const sec = list.querySelector('.hs-brands__grp[data-l="' + b.dataset.hsBrandsL + '"]');
      if (sec) { const y = sec.getBoundingClientRect().top + window.scrollY - (root.querySelector('.hs-brands__rail').offsetHeight + 90); window.scrollTo({ top: y, behavior: 'smooth' }); }
    }));
    apply();
  }
  const run = () => document.querySelectorAll('[data-hs-brands]').forEach(init);
  if (document.readyState !== 'loading') run(); else document.addEventListener('DOMContentLoaded', run);
  document.addEventListener('shopify:section:load', run);
})();

/* HS · sticky add-to-basket: show while the main Add to Basket is off screen (above or below).
   Hyper's observer uses threshold 1, which never fires on phones where the form starts below the fold. */
(function () {
  function setup() {
    const form = document.querySelector('.main-product-form');
    const bars = document.querySelectorAll('sticky-atc-bar-minimalist');
    if (!form || !bars.length) return;
    bars.forEach((b) => { if (b.observer) b.observer.disconnect(); });
    let raf = 0;
    const check = () => {
      raf = 0;
      const hdr = document.querySelector('.header-section, sticky-header, .header'); const top = hdr ? Math.max(0, hdr.getBoundingClientRect().bottom) : 0; const fr = form.getBoundingClientRect(); /* HS R3c: visible whenever the main Add to Basket is off screen — before it scrolls in and after it scrolls past */ const show = fr.bottom < top + 4 || fr.top > window.innerHeight - 4;
      bars.forEach((b) => b.classList.toggle('sticky-atc-bar--show', show));
    };
    window.addEventListener('scroll', () => { if (!raf) raf = requestAnimationFrame(check); }, { passive: true });
    check();
  }
  window.addEventListener('load', () => setTimeout(setup, 300));
})();
